import { useOrgIntegrationConnections } from "@/api/integrations";

export function useGmailConnection() {
  const { data: integrationConnections, isLoading } =
    useOrgIntegrationConnections();

  const gmailConnection = integrationConnections?.find(
    (conn) => conn.slug === "gmail",
  );

  return {
    connectionId: gmailConnection?.id,
    isLoading,
    hasConnection: !!gmailConnection,
  };
}
